<template>
    <div class="topButton-wrapper">
        <button v-on:click="scrollToTop" id="topButton" ref="topButton" title="Ir arriba">
            <svg viewBox="0 0 100 100" class="arrow">
                <path class="arrow" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
                transform="translate(100, 0) rotate(90) "></path>
            </svg>
        </button>
    </div>
</template>

<style lang="scss">
.arrow {
  color: #69303e;
  border: none;
  fill: currentColor;
}

#topButton {
  display: none;
  position: fixed;
  bottom: 50px;
  right: 80px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background: hsla(0, 0%, 100%, 0.80);
  color: #69303e;
  cursor: pointer;
  padding: 15px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  outline: none;
  box-shadow: 0 0 0 0px;
}

#topButton:hover {
  color: #69303e;
  background: hsla(0, 0%, 100%, 1.00);
}
</style>

<script>
export default {
  name: 'ScrollToTopButton',
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        this.$refs.topButton.style.display = 'block'
      } else {
        this.$refs.topButton.style.display = 'none'
      }
    },
    scrollToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
